import * as Yup from "yup";
import { phoneRegex } from "helpers/validators";

export const coRenterSchema = Yup.object({
  birthdate: Yup.string("Birthdate is required")
    .nullable("Birthdate is required")
    .required("Birthdate is required"),
  employer_address_1: Yup.string().required("Employer address is required"),
  employer_city: Yup.string().required("Employer city is required"),
  employer_name: Yup.string().required("Employer name is required"),
  employer_phone: Yup.string()
    .matches(phoneRegex, "Employer phone number is not valid")
    .required("Employer phone is required"),
  employer_state: Yup.string().required("Employer state is required"),
  employer_zip: Yup.string()
    .min(5, "Employer zip must be 5 digits")
    .max(5, "Employer zip must be 5 digits")
    .required("Employer zip is required"),
  drivers_license: Yup.string().required("Drivers license is required"),
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
  email: Yup.string().email("Email is not valid").required("Email is required"),
  home_phone: Yup.string()
    .matches(phoneRegex, "Phone number is not valid")
    .required("Phone number is required"),
  address_1: Yup.string().required("Address is required"),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  zip: Yup.string()
    .min(5, "Zip must be 5 digits")
    .max(5, "Zip must be 5 digits")
    .required("Zip is required"),
});

export function coRenterValid(coRenter) {
  return coRenterSchema.isValidSync(coRenter);
}

export function coRenterValidWithMessages(renter) {
  return coRenterSchema
    .validate(renter, { abortEarly: false })
    .then((v) => [])
    .catch((err) => err.errors);
}
